import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Block = styled.div`
    display: block;
`;

export const GrayBlock = styled(RounderContainer)`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    background-color: ${COLORS.BgSurface};
    padding: 24px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
    }
`;
